import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import LogoCircle from "@/modules/team/components/team-logos/LogoCircle.vue";
import LogoRect from "@/modules/team/components/team-logos/LogoRect.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'TeamLogo',
  props: {
    team: null
  },
  setup(__props) {
    const props = __props;
    const component = computed(() => {
      const logos = [{
        component: LogoCircle,
        attrs: {
          name: true
        }
      }, {
        component: LogoCircle,
        attrs: {
          double: true
        }
      }, {
        component: LogoCircle,
        attrs: {}
      }, {
        component: LogoRect,
        attrs: {
          double: true
        }
      }, {
        component: LogoRect,
        attrs: {}
      }];
      return logos[(props.team.id - 1) % logos.length];
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_resolveDynamicComponent(_unref(component).component), _mergeProps(_unref(component).attrs, {
        team: __props.team
      }), null, 16, ["team"]);
    };
  }
});